<template>
  <div class="page__title">
    <template v-if="!editable">
      <span>{{ value }}</span>
    </template>
    <template v-else>
      <div @mouseover="showEditIcon = true" @mouseleave="showEditIcon = false" class="title1">
        <template v-if="!doEdit">
          {{ value }}
        </template>
        <template v-else>
          <v-text-field
            v-model="title"
            append-outer-icon="mdi-content-save"
            @click:append-outer="runEdit"
            style="max-width: 300px; display: inline-flex;"
          />
          <v-icon class=" pl-1" @click="setDefault" color="grey darken-3">mdi-close</v-icon>
        </template>
        <v-icon v-if="showEditIcon && !doEdit" class="pb-1 pl-1" @click="doEdit = true" color="grey darken-3">mdi-pencil</v-icon>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showEditIcon: false,
      doEdit: false,
      title: "",
    };
  },
  watch: {
    value:{
      handler(val){
        this.title = val;
      },
      immediate: true
    },
  },
  computed: {
    editable() {
      return this.$route.meta.pageTitleEditable;
    },
  },
  methods: {
    runEdit() {
      this.$route.meta.pageTitle = this.title;
      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
      this.$store.commit("PAGE_TITLE_UPDATED", true);
      this.setDefault();
    },
    setDefault() {
      this.showEditIcon = false;
      this.doEdit = false;
      this.title = this.props.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.page{
  &__title{
    height: 36px;
    display: flex;
    align-items: center;
  &::v-deep .v-input {
    display: flex;
    align-items: center;
    max-width: 400px!important;

    &__append-outer{
      margin-bottom: 21px!important;      
    }
    & input{
      font-size: 26px!important;
      font-weight: bold!important;
    }
  }
  }

}
</style>
